import React, {SyntheticEvent} from 'react';
import ModalV4 from '../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../error-boundary";
import deleteAttendance from "./actions/delete-attendance";
import AttendanceFields from "../../model2/attendance-event/fields";
import editAttendance from "./actions/edit-attendance";
import attendance_checkCanEdit from "../../../views/attendance/actions/attendance_check_can_edit";
import VScroll from "../../gd-components/scrolling/custom-v-scroll/v-scroll";
import AttendanceEvent from "../../model2/attendance-event/attendance-event";
import FieldView from "../../fields3/render/view";
import FormFlex from "../../gd-form/form/form-flex/form";
import FormRowFlex from "../../gd-form/form/form-flex/row";
import FieldFormElementView from "../../fields3/render/form-elemnent-view";

type Props = {
    params: {
        clockIn : AttendanceEvent
        clockOut: AttendanceEvent
    }
}

export default class ModalEditAttendance extends ModalV4 {

    public clockIn              : AttendanceEvent
    public clockOut             : AttendanceEvent

    public fields               : AttendanceFields  = new AttendanceFields()

    constructor(props: Props) {
        super(props);

        this.clockIn        = props.params.clockIn
        this.clockOut       = props.params.clockOut
    }

    onClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    editTimestamp = (id: ID, timestamp: Moment)=>{
        if(!timestamp) return
        editAttendance(id, {timestamp: timestamp})
    }

    editLocation = (id: ID, officeId: Moment)=>{
        editAttendance(id, {officeId: officeId})
    }

    editComment = (id: ID, comment: Moment)=>{
        editAttendance(id, {comment: comment})
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">Clock In/Out</div>
        const canEdit = attendance_checkCanEdit(this.clockIn.date)

        return (
            <div className="v4-container placement-middle ui5-iv" style={{width: 840, height: 700}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <div className="iv-left-column iv-column">
                    <div className="details-big-icon">
                        <div className="isvg isvg-clock-in-out"/>
                    </div>

                    <div className="ui5-menu p-t-0">
                        <div className="menu-section open">
                            <div className="item selected">
                                <div className="row">
                                    <div className="icon ii5-information"></div>
                                    <div className="name">Info</div>
                                </div>
                            </div>

                            {canEdit && (
                                <div className="item red"
                                     onClick={() => deleteAttendance(this.props.params.clockIn.id)}>
                                    <div className="row">
                                        <div className="icon i5-trash-alt"></div>
                                        <div className="name">Delete record</div>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
                <ErrorBoundary>
                    <div className="iv-cf-form">
                        <div className="iv-content with-left-panel">
                            <VScroll>
                                <div className="p-l-30">
                                    <FormFlex className="m-t-40  m-l-20">
                                        <FormRowFlex width={150} label="Report date" field={this.fields.date}>
                                            <FieldView field={this.fields.date} model={this.clockIn} className="m-t-8 m-l-10"/>
                                        </FormRowFlex>
                                        <FormRowFlex width={150} label="Reported by user" field={this.fields.createdByUserId}>
                                                <div className="h-36 flex-row-left-center m-l-10">
                                                    <FieldView field={this.fields.createdByUserId} model={this.clockIn}/>
                                                </div>
                                        </FormRowFlex>

                                        <div className="ui5-title-app-name max-w-350 m-t-20 m-b-30">Clock In</div>

                                        <FormRowFlex width={150} label="Time" field={this.fields.timestamp}>
                                            <FieldFormElementView field={this.fields.timestamp}
                                                                  model={this.clockIn}
                                                                  onChange={(value)=>this.editTimestamp(this.clockIn.id, value)}
                                                                  className="w-300" />
                                        </FormRowFlex>
                                        <FormRowFlex width={150} label="Location" field={this.fields.officeId}>
                                            <FieldFormElementView field={this.fields.officeId}
                                                                 model={this.clockIn}
                                                                 onChange={(value)=>this.editLocation(this.clockIn.id, value)}
                                                                 className="w-300" />
                                        </FormRowFlex>
                                        <FormRowFlex width={150} label="Comment" field={this.fields.comment}>
                                            <div className="flex-row-left-center ui5-txt-default">
                                                {canEdit && (
                                                    <FieldFormElementView field={this.fields.comment}
                                                                          model={this.clockIn}
                                                                          className="w-300"
                                                                          onChange={(value) => this.editComment(this.clockIn.id, value)}/>
                                                )}

                                                {!canEdit && <FieldView field={this.fields.comment}
                                                                        model={this.clockIn}
                                                                        className="max-w-300-no-truncate m-l-10"/>}
                                            </div>
                                        </FormRowFlex>

                                        {!!this.clockOut && (
                                            <>
                                                <div className="ui5-title-app-name max-w-350 m-t-20 m-b-30">Clock Out</div>
                                                <FormRowFlex width={150} label="Time" field={this.fields.timestamp}>
                                                    <FieldFormElementView field={this.fields.timestamp}
                                                                          model={this.clockOut}
                                                                          onChange={(value) => this.editTimestamp(this.clockOut.id, value)}
                                                                          className="w-300"/>
                                                </FormRowFlex>
                                                <FormRowFlex width={150} label="Comment" field={this.fields.comment}>
                                                    <div className="flex-row-left-center ui5-txt-default">
                                                        {canEdit && (
                                                            <FieldFormElementView field={this.fields.comment}
                                                                                  model={this.clockOut}
                                                                                  onChange={(value) => this.editComment(this.clockOut.id, value)}
                                                                                  className="w-300"/>
                                                        )}

                                                        {!canEdit && <FieldView field={this.fields.comment}
                                                                                model={this.clockOut}
                                                                                className="max-w-300-no-truncate m-l-10"/>}
                                                    </div>
                                                </FormRowFlex>
                                            </>
                                        )}
                                    </FormFlex>
                                </div>
                            </VScroll>
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}
